import { render, staticRenderFns } from "./PrivateEmail.vue?vue&type=template&id=1f0ca9c8&"
import script from "./PrivateEmail.vue?vue&type=script&lang=js&"
export * from "./PrivateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports